import { useEffect } from "react";
import { FLEX_COL_FILL } from "../../../../../themes/sbux/components";
import { Box } from "@mui/material";
import SbuxEnhancedTable from "../../../../../components/SbuxTable/SbuxEnhancedTable";
import SbuxLoader from "../../../../../components/SbuxLoader";
import { getQueue, getResetQueue } from "../../../../../services/queue";
import { columns } from "./columns";
import QueueRow from "./QueueRow";
import {
  getQueueLoadingSelector,
  getQueueDataSelector,
} from "../../../../../selectors/queueSelector";
import { getConnectedInstanceSelector } from "../../../../../selectors/userInstanceSelector";
import { useAppDispatch, useAppSelector } from "../../../../../store/types";

interface ConnectedInstance {
  instanceId?: string;
  [key: string]: unknown;
}

const QueueTabs = () => {
  const dispatch = useAppDispatch();

  const queueLoading = useAppSelector(getQueueLoadingSelector);
  const queueData = useAppSelector(getQueueDataSelector) as Record<
    string,
    unknown
  >[];
  const connectedInstance = useAppSelector(
    getConnectedInstanceSelector,
  ) as ConnectedInstance | null;

  useEffect(() => {
    if (connectedInstance?.instanceId) {
      fetchData(connectedInstance.instanceId);
    }

    return () => {
      dispatch(getResetQueue());
    };
  }, [connectedInstance?.instanceId]);

  const fetchData = async (instanceId: string) => {
    await dispatch(getQueue(instanceId));
  };

  const handleRefrehClick = async () => {
    if (connectedInstance?.instanceId) {
      await fetchData(connectedInstance.instanceId);
    }
  };

  return (
    <Box sx={FLEX_COL_FILL}>
      {queueLoading ? (
        <SbuxLoader />
      ) : (
        <SbuxEnhancedTable
          rows={queueData}
          columns={columns}
          defaultSortingField={"Name"}
          defaultSortOrder={"asc"}
          RowSource={QueueRow}
          showFooter={true}
          showSearchBar={true}
          isManager={true}
          handleRefreshClick={handleRefrehClick}
          footerMarginBottom={"0"}
        />
      )}
    </Box>
  );
};

export default QueueTabs;
